import React from 'react'
import BookMarkSVG from '../icons/bookMarkSVG'
import ClockSVG from '../icons/clockSVG'
import SecuritySVG from '../icons/securitySVG'

const Features = () => {
  return (
    <section id="features">
      <div className="pt-16 pb-8 md:pt-12 layout-space lg:pt-20 xl:pt-32 xl:pb-32">
        <div className=" md:text-center md:mb-16">
          <h2 className="mb-3 heading">Больше, чем приложение для расшифровки</h2>
          <p className="mb-8 sub-heading">
            Продуктивная работа с аудиозаписями и расшифровками – достигайте еще больше результатов за меньшее время!
          </p>
        </div>
        <div className="max-w-6xl mx-auto md:flex lg:px-10">
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1 blue-dot-after">
            <div className="pt-6 pb-4">
              <ClockSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">ОТПРАВКА НА EMAIL</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              За считанные минуты
            </h4>
            <p className="pb-6 small">
              Голосовые заметки расшифровываются и автоматически отправляются на вашу электронную почту
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <SecuritySVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">ПОЛНАЯ БЕЗОПАСНОСТЬ</h3>
            <h4 className="my-1 sub-heading text-accent bold">Постоянная синхронизация</h4>
            <p className="pb-6 small">
              Все встречи, конспекты, голосовые заметки и расшифровки резервируются в облаке (iCloud, Dropbox, Google Drive)
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <BookMarkSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">ЛИДЕР ИНДУСТРИИ</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              Расшифровка на базе ИИ
            </h4>
            <p className="pb-6 small">
              Расшифровка человеком занимает не один час. VoxRec делает это автоматически, повышая продуктивность любых совещаний и совместной работы.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Features
